<template>
  <span class="icon icon--logo">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <circle cx="20" cy="20" r="20"></circle>
      <path d="M32.75,21.72a1.82,1.82,0,0,0-3.64.15,3.65,3.65,0,0,
      1-7.29,0h0V20.54a1.51,1.51,0,0,0,.42.05h.91a1.82,1.82,0,1,
      0,0-3.64h-.91a2,2,0,0,0-.42.05V12.67h0v-.14a.43.43,0,0,1,
      0-.11l0-.17-.06-.17a1,1,0,0,0-.06-.16,1.09,1.09,0,0,
      0-.08-.15l-.09-.14a.76.76,0,0,0-.11-.14l-.11-.12-.14-.12L21,
      11.15l-.18-.1L20.69,11l-.21-.07-.12,0a1.39,1.39,0,0,0-.35,
      0h0a1.39,1.39,0,0,0-.35,0l-.12,0-.21.07-.13.06-.18.1-.12.09-.14.12-.11.12a.76.76,
      0,0,0-.11.14l-.09.14a1.09,1.09,0,0,0-.08.15,1,1,0,0,0-.06.16l-.06.17,
      0,.17a.43.43,0,0,1,0,.11v.14h0v9.2h0a3.65,3.65,0,0,1-7.29,
      0,1.82,1.82,0,0,0-3.64-.15v.15A7.28,7.28,0,0,0,20,
      26.67a7.28,7.28,0,0,0,12.75-4.8Z"
            style="fill: #fefeff;fill-rule: evenodd"
      ></path>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'Logo',
};
</script>
